import { createFileRoute } from "@tanstack/react-router";

import ProjectSetup from "~/pages/RecordLabelling/ProjectSetup";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/record-labelling-admin/setup")({
  staticData: ROUTE_STATIC.recordLabellingAdmin,
  component: ProjectSetup,
});
